import { Component } from "preact";

import Layout from "../../components/layout/Layout";

class IframeTest extends Component {
  render() {
    return (
      <Layout>
        <a
          href="https://events-staging.humanitix.net/jakes-demo/tickets"
          style="border-radius:4px;background:#6621c0;font-family: Helvetica;font-size:16px;color:#FFFFFF;text-align:center;padding: 4px 18px;text-decoration: none;display: inline-block;"
        >
          Staging
        </a>
        <a
          href="http://localhost:8080/jakes-demo/tickets"
          style="border-radius:4px;background:#6621c0;font-family: Helvetica;font-size:16px;color:#FFFFFF;text-align:center;padding: 4px 18px;text-decoration: none;display: inline-block;"
        >
          Local
        </a>
      </Layout>
    );
  }
}

export default IframeTest;
